import { Button, TextField, TextareaAutosize } from '@mui/material';
import React, { useEffect, useState } from 'react';
//import ImageUploader from './ImageUploader';
import ImageUploaderNew from './ImageUploaderNew';
import { GriderLayout } from './GriderLayout';
import { generateSlug } from '../../../helpers/randoms';
import StripeComponent from './StripeComponent';

const PageForm = ({ data = {}, onUpdate, isHome=false }) => {
  console.log('in page form: new',data);
  //const [slugEditedManually, setSlugEditedManually] = useState(false);
  const [pageData, setPageData] = useState(data || {});
  const [pageTitle, setPageTitle] = useState(data.title || '');
  const [pageName, setPageName] = useState(data.name || '');
  const [pageURL, setPageURL] = useState(data.url || '');
  const [redirectTo, setRedirectTo] = useState(data.redirectTo || '');
  const [is404Page, setIs404Page] = useState(data.is404 || false);
  const [slugEditedManually, setSlugEditedManually] = useState(false);
  const [nameEditedManually, setNameEditedManually] = useState(false);
  const [pageCSS, setPageCSS] = useState(data?.data?.pageCSS || '');

  const handleSave = () => {
    let toSaveData = isHome ? {data: {...data.data, pageCSS: pageCSS}} : {name: pageName, title: pageTitle, url: pageURL, data: {...data.data, pageCSS: pageCSS}}; //, redirectTo: redirectTo, is404: is404Page};
    onUpdate(toSaveData);
  };

  useEffect(() => {
    // If the initial slug is not the auto-generated version of the name,
    // assume it was manually set.
      if (data.url && data.url !== generateSlug(data.title)) {
        setSlugEditedManually(true);
      }
      if (data.name && data.name !== data.title) {
          setSlugEditedManually(true);
      }
  }, [data.title, data.url, data.name]);


  const handleTitleChange = (title) => {
    console.log(title)
    setPageTitle(title);
    // If slug hasn't been edited manually, generate and set slug based on name
    if (!slugEditedManually) {
      setPageURL(generateSlug(title));
    }
    // if display name is blank
    if (!nameEditedManually) {
      setPageName(title);
    }
  }
  
  const handleSlugChange = (slug) => {
    setPageURL(slug);
    setSlugEditedManually(true);  // Mark slug as edited manually
  };

  const handleNameChange = (name) => {
    setPageName(name);
    setNameEditedManually(true);  // Mark slug as edited manually
  };


  return (
    <div>
      {/*<StripeComponent />*/}
      {!isHome && <>
      <label>
        <TextField 
          variant="outlined"
          fullWidth 
          style={{ marginTop: 11 }}
          label={'Display Name/Page Title'}
          value={pageTitle}
          onChange={(e) => handleTitleChange(e.target.value)}
        />
      </label>
      <label>
        <TextField 
          variant="outlined"
          fullWidth 
          style={{ marginTop: 11 }}
          label={'Internal Name'}
          value={pageName}
          onChange={(e) => handleNameChange(e.target.value)}
        />
      </label>
      <label>
        <TextField 
          variant="outlined"
          fullWidth 
          style={{ marginTop: 11 }}
          label={'URL'}
          placeholder='Provide the last part of the URL, else Page Name will be taken as URL'
          value={pageURL}
          onChange={(e) => handleSlugChange(e.target.value)}
        />
      </label>
      </>}
      <TextareaAutosize
            name="pageCSS"
            minRows={4}
            style={{width: '100%', fontFamily: 'monospace !important'}}
            aria-label="Page CSS"
            placeholder='Write this page specific css here'
            value={pageCSS}
            onChange={(e) => setPageCSS(e.target.value)}
        />
      <br />
      <Button onClick={handleSave} fullWidth className='my-3' variant='outlined' color='primary'>Save</Button>
    </div>
  );
};

export default PageForm;
